import {css} from '@emotion/react';
import styled from '@emotion/styled';

import background from '@/assets/images/cross-border-background-v2.jpeg';

type Props = {
  size: 'small' | 'medium' | 'large';
};

export const Container = styled.a<Props>(
  ({theme, size}) => css`
    display: block;
    overflow: hidden;
    padding: ${{
      small: '12px',
      medium: '12px',
      large: '16px',
    }[size]};
    text-decoration: none;
    color: ${theme.colors.contentInversePrimary};
    background: url('${background}') bottom right no-repeat;
    background-size: cover;
    border-radius: 5px;
  `
);
